export const globalSettings = {
  itemsPerPageOptions: [5, 10, 15, 20, 50, 100, 200],
};
